import * as Sentry from "@sentry/react";

import {
  BASE_API_URL,
  BASE_BENEFICIARY_API_URL,
  DOCUMENT_HANDLER_API_URL,
} from "../config";
import axios, { AxiosRequestConfig } from "axios";

import { StorebrandKeycloak } from "@storebrand-digital/storebrand-auth";
import { sanitizeString } from "./sentryUtils";

// The URLs where we should attach token.
const authenticatedUrls = [
  BASE_API_URL,
  DOCUMENT_HANDLER_API_URL,
  BASE_BENEFICIARY_API_URL,
  "customer/document/",
];

// Intercept requests to API and configure header to attach token.
export async function initAxiosInterceptor() {
  axios.interceptors.request.use(async (config) => {
    const req: AxiosRequestConfig = { ...config };

    if (
      StorebrandKeycloak.authenticated() &&
      (authenticatedUrls.some(
        (url) => req && req.url && req.url.includes(url),
      ) ||
        window.env.environment === "development")
    ) {
      if (req?.url?.includes("assets")) {
        return req;
      }
      if (req && req.headers) {
        req.headers.Accept = "application/json";
        req.headers.ClientId = "edh2-customer-web";
        req.headers.Authorization = `Bearer ${await StorebrandKeycloak.getToken()}`;
      } else {
        const failedUrl = req?.url ? req.url : "";
        Sentry.setTag("apiUrl", sanitizeString(failedUrl));
        Sentry.setContext("auth", {
          name: "interceptor",
          function: "initAxiosInterceptor",
          href: sanitizeString(failedUrl),
        });
        Sentry.captureEvent({
          message: "Request headers are undefined",
        });
      }
    }

    /* Redirect to login if not authenticated.*/
    if (!StorebrandKeycloak.authenticated()) {
      StorebrandKeycloak.login();
    }

    return req;
  });
}

export const ACCEPTED_EVIDENCE_FILE_TYPES = {
  "application/vnd.oasis.opendocument.text": ".odt",
  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    ".docx",
  "application/vnd.ms-outlook": ".msg",
  "application/pdf": ".pdf",
  "text/plain": ".txt",
  "application/wordperfect": ".wpd",
  "application/rtf": ".rtf",
  "image/jpeg": ".jpg",
  "image/tiff": ".tif",
  "image/bmp": ".bmp",
  "image/png": ".png",
};

export const isAcceptedEvidenceFileType = (fileType: string) => {
  return Object.keys(ACCEPTED_EVIDENCE_FILE_TYPES).includes(fileType);
};

export const getAcceptedEvidenceMimeTypes = () => {
  return `${Object.values(ACCEPTED_EVIDENCE_FILE_TYPES).join(",")}`;
};
